<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <items
      :items="items"
      :cart-total="cartTotal"
      :shipping="shipping"
    />

    <payment-simple
      v-if="itemsInCart"
      :currency-icon="currencyIcon"
      :currency="currencies[0]"
      :items="items"
      :total-amount="cartTotal + shipping.cost"
      :shipping="shipping"
      v-on="$listeners"
    />
  </v-container>
</template>

<script>
  import Items from './items/Index'
  import PaymentSimple from '../../payment/Simple'

  export default {
    components: {
      Items,
      PaymentSimple,
    },
    data(){
      return {
        creditCardComponent: '',
        shipping: {}
      }
    },
    computed:{
      items () {return this.$store.getters['market/cartItems'](this.context)},
      cartTotal () {return this.$store.getters['market/cartTotal'](this.context)},
      itemsInCart(){return !!this.$store.getters['market/cartItemCount'](this.context)},
      checks(){return this.$store.state.market.shippingAddress.checks || {}},
      currencyIcon(){
        return (this.items[0]||{}).currency_icon || 'mdi-currency-sign'
      },
      currencies(){
        return this.shipping && this.shipping.products && this.shipping.products.reduce((a,i)=>{
          const curr = (i.properties||{}).currency
          if (!a.includes(curr)) {
            a.push(curr)
          }
          return a
        }, []) || []
      }
    },
    watch:{
      checks(){
        if (this.checks && this.checks.email && this.checks.address) {
          this.creditCardComponent = 'cart-stripe-element'
        }
      }
    },
    watch: {
      items(v) {
        this.fetch(v)
      }
    },
    mounted () {
      this.fetch(this.items);
    },
    methods: {
      async fetch(items) {
        this.shipping = await this.api.post('/product/shipping', {items})
      }
    },
  }
</script>